<template>
  <div>
    <v-card outlined class="pa-2 round d-flex align-end" color="grey lighten-2" style="border-radius: 12px;">
      <v-row>
        <v-col
          cols="2"
          class="grid"
          style="padding: 0px; justify-content: center"
        >
          <!-- <div > -->
          <v-img
            style="
              max-height: 50px;
              max-width: 40px;
              width: 70%;
              margin: 15% !important;
            "
            :src="
              require('@/assets/fontawesome/lock-duotone.svg')
            "
          />
          <!-- </div> -->
        </v-col>
        <v-col >
          <p class="d-flex align-end mt-3" style="font-size: 12px" color="black">
            It's important that all transactions are done
            over Strapps platform, otherwise we cannot
            ensure the safety of your transaction or item.
          </p>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'StrappDisclaimer',

  data() {
    return {

    };
  },

  mounted() {

  },

  methods: {

  },
};
</script>

<style lang="scss" scoped>

</style>
